import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

function RoleRoute({ allowedRoles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <RouteState>Preparando tu espacio…</RouteState>;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (user.isAdmin) return children;

  const roleAliases = {
    USER: 'CLIENT',
    PARTICULAR: 'CLIENT',
    INMOBILIARIA: 'PROFESSIONAL',
    DESARROLLADORA: 'PROFESSIONAL',
  };
  if (allowedRoles.includes('ADMIN')) {
    return <RouteState>No tenés permisos para acceder a esta sección.</RouteState>;
  }

  const normalizedRole = roleAliases[String(user.role || '').toUpperCase()]
    || String(user.role || '').toUpperCase();

  if (!allowedRoles.includes(normalizedRole)) {
    return <RouteState>No tenés permisos para acceder a esta sección.</RouteState>;
  }

  return children;
}

export default RoleRoute;

const RouteState=({children})=><div style={{minHeight:'60vh',display:'grid',placeItems:'center',padding:24,background:'#f7f5ef',color:'#52676c',fontWeight:750,textAlign:'center'}}>{children}</div>;
